import { render } from "./processesDetailPanel.vue?vue&type=template&id=2a6112a0"
import script from "./processesDetailPanel.vue?vue&type=script&lang=js"
export * from "./processesDetailPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__